module.exports = __webpack_public_path__ + "img/conimg3-05.418108c5.png";